import {
	Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, ElementRef,
	OnChanges, SimpleChanges, ChangeDetectorRef, TemplateRef
} from '@angular/core';
import {ISelectionBoxItem} from "../../../interfaces/Iselection.box.item";
import {ISelectionBoxActionEvent} from "../../../interfaces/Iselection.box.action.event";

@Component({
	selector: 'cp-sb-content',
	templateUrl: './selection.box.content.html',
	styleUrls: ['./selection.box.content.scss'],
	//directives: [SelectionListComponent, SelectionDiagramComponent],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionBoxContentComponent implements OnChanges{

	@Input() data: ISelectionBoxItem[];
	@Input() subTitle:string;
	@Input() diagramPath: string;
	@Input() displayDiagram: boolean;
	@Input() locateSelected: boolean;
	@Input() itemTemplate: TemplateRef<any>;
	@Input() searchTerms: string[];

	@Output() selectItem: EventEmitter<ISelectionBoxItem> = new EventEmitter<ISelectionBoxItem>();
	@Output() actionClick: EventEmitter<ISelectionBoxActionEvent> = new EventEmitter<ISelectionBoxActionEvent>();
	@Output() subTitleClick = new EventEmitter();

	@ViewChild('list', {read: ElementRef,static:false}) listRef: ElementRef;

	constructor(private changeDetector: ChangeDetectorRef){
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.locateSelected){
				setTimeout(() => {
					this.setScrollByActiveItem();
				this.changeDetector.markForCheck(); // why is this required?
				});
		}
	}

	public onSelect(item: ISelectionBoxItem) {
		this.selectItem.emit(item);
	}

	public onActionClick(event:ISelectionBoxActionEvent){
		this.actionClick.emit(event);
	}

	public onSubTitleClick(){
		this.subTitleClick.emit(null);
	}

	public setScrollByActiveItem() {

		let listElm = this.listRef.nativeElement;
		let elements = listElm.getElementsByClassName("active");
		if (elements && elements.length > 0 && elements[0]) {
			let selectedTop = elements[0].getClientRects()[0].top;
			let containerTop = listElm.getClientRects()[0].top;
			this.listRef.nativeElement.scrollTop = selectedTop - containerTop + listElm.scrollTop - listElm.offsetHeight / 2;
		}
	}

}
